<template>
  <sales-table
    v-if="!!orderStock"
    :title="$t('key_orders_out_of_stock')"
    :rows="orderStock['items']"
    :pagination="pagination"
    :headers="headers"
    @changed-page="paginationPageChange"
    @row-change="paginationRowChange"
  >
    <template #row="order">
      <td>
        <a class="cursor-pointer text-xs picko-link mb-0" :title="$t('key_view_order')"
              @click="goOrderDetail(order._id)">
              {{order.number}}
            </a>
      </td>
      <td class="font-weight-bold text-end">
        <span class="my-2 text-xs">{{ Math.abs(order.units.booked - order.units.requested) }}</span>
      </td>
    </template>
  </sales-table>
</template>
<script>
import SalesTable from "./SalesTable.vue";

export default {
  name: "PendingOrderStock",
  components: {
    SalesTable,
    // Globe,
  },
  props: {
    label: {
      type: String,
      default: "Numero",
    },
  },
  data() {
    return {
      pagination: {
        total: 0,
        rows: 5,
        currentPage: 1,
        pages: {
          total: 5,
          current: 1
        },
        entries: [5, 10, 15, 20, 50]
      }
    };
  },
  computed: {
    orderStock() {
      return this.$store.state.dashboard.orderStocks.data;
    },
    headers() {
      return [
        { title: this.$t('key_theader_Out_of_stock_order_number'), sort:{sorteable:false,order:""}, column: "number", class: "text-start"},
        { title: this.$t('key_theader_Out_of_stock_number_of_items'), sort:{sorteable:false,order:""}, column: "booked", class: "text-end"},
      ]
    }
  },
  watch: {
    orderStock() {
      if(this.orderStock) {
        if (this.orderStock["total"]) {
          this.pagination.total = this.orderStock["total"];
        } else {
          this.pagination.total = 0;
        }
      }
    },
  },
  mounted() {
    this.getOrders()
  },
  methods: {
    goOrderDetail(productId){
      this.$router.push({ path: "/Operations/Orders/OrderDetail/" + productId});
    },
    getOrders(){
      this.$store.commit("dashboard/getOrderStock" , {
        filters: {
          sort: {
            sort: "number",
            order: "ascending"
          }
        },
        pagination: this.pagination
      });
    },
    paginationPageChange(page) {
      this.pagination.currentPage = page;
      this.getOrders();
    },
    paginationRowChange(rows) {
      this.pagination.rows = rows;
      this.getOrders(); 
    },
  }
};
</script>
<style scoped>
.pointer {
  cursor: pointer;
}
</style>